import { isSalesViewEnabled, toggleSalesView, useSalesViewState } from '@ab-core-functions/sales-view';
import { userCanHidePrices, userHasOnlySalesView } from '@ab-core-functions/user-permission';
import { useAuth } from '@ab-core/hooks';
import { getTestIdProp } from '@ab-core/testing';
import { toast } from '@ab-core/toast';
import React from 'react';
import { ElementContainer } from '../elementContainer/elementContainer';

export const SalesView = () => {
    const canHidePrices = userCanHidePrices();
    const userHasOnlySalesViewRight = userHasOnlySalesView();
    const displaySalesView = useSalesViewState();
    const { user } = useAuth();

    const updateDisplayView = () => {
        toggleSalesView(user?.activeAccount?.accountNumber || '');
        const showView = isSalesViewEnabled(user?.activeAccount?.accountNumber);

        if (showView) {
            toast.info('Einkaufspreis Änderung', 'Der Einkaufspreis wurde ausgeblendet');
        } else {
            toast.info('Einkaufspreis Änderung', 'Der Einkaufspreis wurde eingeblendet');
        }
    };

    return (
        <>
            {canHidePrices && !userHasOnlySalesViewRight && (
                <ElementContainer
                    {...getTestIdProp('hide-show-prices-button')}
                    iconName={displaySalesView ? 'NotVisible' : 'Visible'}
                    onClick={updateDisplayView}
                />
            )}
        </>
    );
};
